import React from 'react';
import { Link as RouterLink, Route } from 'react-router-dom';
import { FontIcon } from 'react-md';

const NavLink = ({ label, to, exact, icon, onClick }) => (
  <Route path={to} exact={exact}>
    {({ match }) => {
      const isActive = !!match;

      return (
        <RouterLink to={to} style={{ textDecoration: 'none' }} onClick={onClick}>
          <div style={{
            ...styles.navItem,
            ...(isActive ? styles.navItemActive : {}),
          }}>
            {icon && (
              <FontIcon style={{
                ...styles.icon,
                ...(isActive ? styles.iconActive : {}),
              }}>
                {icon}
              </FontIcon>
            )}
            <span style={{
              ...styles.label,
              ...(isActive ? styles.labelActive : {}),
            }}>
              {label}
            </span>
            {isActive && <div style={styles.activeBar} />}
          </div>
        </RouterLink>
      );
    }}
  </Route>
);

const styles = {
  navItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    borderRadius: 8,
    marginBottom: 4,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    position: 'relative',
  },
  navItemActive: {
    backgroundColor: '#FFF8EC',
  },
  icon: {
    fontSize: 20,
    color: '#666',
    marginRight: 12,
  },
  iconActive: {
    color: '#F5A623',
  },
  label: {
    fontSize: 14,
    fontWeight: 400,
    color: '#555',
  },
  labelActive: {
    color: '#F5A623',
    fontWeight: 600,
  },
  activeBar: {
    position: 'absolute',
    left: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 3,
    height: '60%',
    backgroundColor: '#F5A623',
    borderRadius: '0 3px 3px 0',
  },
};

export default NavLink;
